import basePath from "base_path";

import ActionTypes, {MattersActionTypes} from "../constants/action_types";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import {MatterDocument} from "common/types/matter";

export type DcDocumentRefreshAction = {
  type: MattersActionTypes["DC_DOCUMENT_REFRESH"]["SUCCESS"];
  payload: MatterDocument;
};

export default function refreshDcDocument(requestor) {
  return createReduxPromiseAction(
    ActionTypes.DC_DOCUMENT_REFRESH,
    (organisationId, projectId, matterId, documentId) => {
      const reqString = `${basePath}/organisation/${organisationId}/project/${projectId}/matter/${matterId}/document/${documentId}/refresh`;
      return requestor
        .get(reqString, {withCredentials: true})
        .then(response => ({
          organisation_id: parseInt(organisationId, 10),
          project_id: parseInt(projectId, 10),
          document_id: parseInt(documentId, 10),
          ...response.data,
        }));
    },
  );
}
